import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, Observable, switchMap, timeout } from 'rxjs';
import { API_BASE_URL, CALLABLE_TIMEOUT_MS, SKIP_AUTH } from './auth-config';
import { KeycloakAuthClient } from './keycloak-auth-client';

/**
 * Attaches the Keycloak bearer token to backend calls and bounds every call in time.
 * Only requests to our own backend get the token, so a third-party URL never sees it.
 */
export function authInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const base: string = inject(API_BASE_URL);
    if (request.context.get(SKIP_AUTH) || !request.url.startsWith(base)) {
        return next(request).pipe(timeout(CALLABLE_TIMEOUT_MS));
    }

    const authClient: KeycloakAuthClient = inject(KeycloakAuthClient);
    return from(authClient.getAccessToken()).pipe(
        switchMap((token: string | null): Observable<HttpEvent<unknown>> => next(
            token ? request.clone({ setHeaders: { Authorization: `Bearer ${ token }` } }) : request,
        )),
        timeout(CALLABLE_TIMEOUT_MS),
    );
}
